import { Injectable, ErrorHandler } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { KeyValue } from '@angular/common';
import {
  IAddressDto,
  IApiResponse,
  IDeliveryTypePriceInfoDto,
  IOutletDistanceDto,
} from '../models';

@Injectable()
export class AddressService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getAddressList(): Observable<IAddressDto[]> {
    return this.get(`address`);
  }

  public getAddress(id: number): Observable<IAddressDto> {
    return this.get(`address/${id}`);
  }

  public saveAddress(model: IAddressDto): Observable<IApiResponse<boolean>> {
    return this.post(`address`, model);
  }

  public updateAddress(model: IAddressDto): Observable<IApiResponse<boolean>> {
    return this.put(`address`, model);
  }

  public deleteAddress(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`address/${id}`);
  }

  public validateDistance(
    model: IAddressDto,
  ): Observable<IApiResponse<IDeliveryTypePriceInfoDto>> {
    return this.post(`address/distance`, model);
  }

  public validateDistanceWithMiles(
    model: IAddressDto,
  ): Observable<IApiResponse<IDeliveryTypePriceInfoDto>> {
    return this.post(`address/distance/miles`, model);
  }

  public getDistance(
    model: IOutletDistanceDto,
  ): Observable<KeyValue<number, string>[]> {
    return this.post(`address/outletDistance`, model);
  }
}
